import IBModuleApi from "../../api/iuviBankingAPI";
import { urlContexts } from "../../constants";

export const getTransactions = async (appId: string, transactionId?: number) => {
  const { data } = await IBModuleApi.get(
    `${IBModuleApi.defaults.baseURL}/${urlContexts.console}/rest/1.0/cs/transaction${
      transactionId ? `/${transactionId}?appId=${appId}` : `?appId=${appId}`
    }`
  );

  return data;
};

export const createTransaction = async (createInfo: any, appId: string) => {
  const { data } = await IBModuleApi.post(
    `${IBModuleApi.defaults.baseURL}/${urlContexts.console}/rest/1.0/cs/transaction?appId=${appId}`,
    createInfo
  );

  return data;
};

export const updateTransaction = async (updateInfo: any, appId: string) => {
  const { data } = await IBModuleApi.put(
    `${IBModuleApi.defaults.baseURL}/${urlContexts.console}/rest/1.0/cs/transaction?appId=${appId}`,
    updateInfo
  );

  return data;
};

export const updateTransactionProperty = async (updateInfo: any, appId: string) => {
  const { data } = await IBModuleApi.put(
    `${IBModuleApi.defaults.baseURL}/${urlContexts.console}/rest/1.0/cs/transactionproperty?appId=${appId}`,
    updateInfo
  );

  return data;
};

export const deleteTransaction = async (transactionId: number) => {
  const { data } = await IBModuleApi.delete(
    `${IBModuleApi.defaults.baseURL}/${urlContexts.console}/rest/1.0/cs/transaction/${transactionId}`
  );

  return data;
};